import React, { useState } from 'react';
import Table from '../common/Table';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import Ratings from '../common/Rating';
import Type from '../common/Types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ReviewsAndRatings from '../ReviewsAndRatings';
import { Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { Chart } from 'react-google-charts';

const UsersByCountry = (props) => {
  const { classes } = props;
  return (
    <Card className={classes.root}>
    <CardHeader subheader="Users By Country" classes={{ subheader: classes.header }} />
    <CardContent>
      <Chart
        width={'100%'}
        height={'300px'}
        chartType="GeoChart"
        data={[
          ['Country', 'Popularity'],
          ['Germany', 200],
          ['United States', 300],
          ['Brazil', 400],
          ['Canada', 500],
          ['France', 600],
          ['RU', 700],
          ['India', 500],
        ]}
        // Note: you will need to get a mapsApiKey for your project.
        // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
        mapsApiKey="YOUR_KEY_HERE"
        rootProps={{ 'data-testid': '1' }}
      />
    </CardContent>
  </Card>)
};

export default UsersByCountry;
